var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18C0 8.08594 8.01562 0 18 0C27.9141 0 36 8.08594 36 18C36 27.9844 27.9141 36 18 36C8.01562 36 0 27.9844 0 18ZM18.4399 24.9947C18.2026 25.1133 18.0246 25.1727 17.8466 25.1727C17.2534 25.1727 16.7788 24.8167 16.5415 24.3421L15.8295 22.7403H8.41377L7.70186 24.3421C7.40523 25.054 6.57466 25.3506 5.80342 24.9947C5.0915 24.6981 4.79487 23.8082 5.15083 23.0963L10.8461 10.7564C11.3208 9.74786 12.9226 9.74786 13.3972 10.7564L19.0925 23.0963C19.4484 23.8082 19.1518 24.6981 18.4399 24.9947ZM9.71973 19.8943H14.4658L12.1521 14.7329L9.71973 19.8943ZM29.8405 17.186C30.4918 16.4402 30.9031 15.4571 30.9031 14.3722C30.9031 11.9992 28.915 10.033 26.5156 10.033H22.1281C21.5111 10.033 21.0312 10.5415 21.0312 11.1178V24.1356C21.0312 24.7458 21.5111 25.2205 22.1281 25.2205H27.6125C30.0119 25.2205 32 23.2881 32 20.8812C32 19.3217 31.1088 17.9318 29.8405 17.186ZM23.225 12.2365H26.5156C27.7153 12.2365 28.7094 13.1857 28.7094 14.4061C28.7094 15.5927 27.7153 16.5758 26.5156 16.5758H23.225V12.2365ZM27.6125 23.0508H23.225V18.7115H27.6125C28.8122 18.7115 29.8062 19.6946 29.8062 20.8812C29.8062 22.1016 28.8122 23.0508 27.6125 23.0508Z",
    fill: "#4BB218"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbIcon);
export default __webpack_public_path__ + "static/media/ABIcon.fb77c422fa75b9a1825aa7bc0440e158.svg";
export { ForwardRef as ReactComponent };